export default __webpack_public_path__ + "static/media/quick2.7b74827e.png";